import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, MenuItem, Select } from '@mui/material';
import { getGrupos } from '../Grupo/Grupo-Api';

const IaxGroupFilter = ({ open, onClose, selectedItem, setSelectedItem }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchData = () => {
      getGrupos(setItems);
    };

    if (open) {
      fetchData();
    }
  }, [open]);

  const handleItemChange = (event) => {
    setSelectedItem(event.target.value);
    onClose();
  };

  const handleClearFilter = () => {
    setSelectedItem("GRUPO");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Selecciona un grupo</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Por favor, elige un grupo de la lista.
        </DialogContentText>
        <FormControl fullWidth>
          <Select
            labelId="item-selector-label"
            id="item-selector"
            value={selectedItem}
            onChange={handleItemChange}
          >
            {items.map((item) => (
              <MenuItem key={item.id} value={item.nombre}>
                {item.nombre}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClearFilter}>quitar filtro</Button>
      </DialogActions>
    </Dialog>
  );
};

export default IaxGroupFilter;
